module.exports = __webpack_public_path__ + "assets/img/aden.1bbe4483.jpg";